import {Component, HostListener, inject} from '@angular/core';
import {BreakpointService} from '../../services/breakpoint.service';

@Component({
  selector: 'breakpoint-debug',
  template: `
    <div class="fixed bottom-4 left-4 z-50 bg-black/80 text-white p-3 rounded-lg font-mono text-sm">
      <div class="mb-2 font-bold">Breakpoint Debug</div>
      <div class="space-y-1">
        @for (bp of breakpointEntries; track bp.name) {
          <div [class]="getBreakpointClass(bp.name)">
            <span class="inline-block w-3 h-3 rounded-full mr-2" [class]="getIndicatorClass(bp.name)"></span>
            {{bp.name.toUpperCase()}}: {{bp.value}}px+
          </div>
        }
      </div>
      <div class="mt-2 pt-2 border-t border-gray-600">
        <div class="text-xs">Largeur: {{screenWidth}}px</div>
        <div class="text-xs font-bold text-green-400">Actuel: {{currentBreakpoint}}</div>
      </div>
    </div>
  `,
  standalone: true
})
export class BreakpointDebugComponent {
  private breakpointService = inject(BreakpointService);

  screenWidth = 0;
  currentBreakpoint = '';
  breakpointEntries: {name: string, value: number}[] = [];

  constructor() {
    this.initBreakpoints();
    this.updateScreenWidth();
  }

  private initBreakpoints() {
    const breakpoints = this.breakpointService.getBreakpoints();
    this.breakpointEntries = Object.entries(breakpoints)
      .map(([name, value]) => ({
        name,
        value: typeof value === 'string' ? parseInt(value.replace('px', '')) : 0
      }))
      .sort((a, b) => a.value - b.value);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.updateScreenWidth();
  }

  private updateScreenWidth() {
    this.screenWidth = window.innerWidth;
    this.currentBreakpoint = this.breakpointService.getCurrentBreakpoint(this.screenWidth);
  }

  getBreakpointClass(breakpoint: string): string {
    return this.currentBreakpoint === breakpoint ? 'text-green-400 font-bold' : 'text-gray-400';
  }

  getIndicatorClass(breakpoint: string): string {
    return this.currentBreakpoint === breakpoint ? 'bg-green-400' : 'bg-gray-600';
  }
}
